var exports = {
  "x": "templateVars__fB_Ln5",
};

module.exports = exports;
